import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileUploadTip'
})
export class FileUploadTipPipe implements PipeTransform {

  transform(value: string): any {
    let tips
    if(value){
      tips = value.split('; ')
    } else {
      tips = []
    }
    let fileTypeTip = tips[0]
    if(fileTypeTip && fileTypeTip.indexOf('请在上传策略中配置允许上传类型') == -1){
      let typeStr = fileTypeTip.split(':')[1]
      let newTypeStr = typeStr
      let typeArr = typeStr.split(',')
      if(typeArr.length > 2){
        newTypeStr = typeArr[0]+','+typeArr[1]+' 等'
      }
      let newValue = value.replace(typeStr,newTypeStr)
      return newValue
    } else {
      return value;
    }
  }

}
